import { render, staticRenderFns } from "./SkillsCard.vue?vue&type=template&id=1b264537&scoped=true"
import script from "./SkillsCard.vue?vue&type=script&lang=js"
export * from "./SkillsCard.vue?vue&type=script&lang=js"
import style0 from "./SkillsCard.vue?vue&type=style&index=0&id=1b264537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b264537",
  null
  
)

export default component.exports